var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon),expression:"showIcon"}],attrs:{"title":_vm.metadata && _vm.metadata.tooltip ? _vm.$t(_vm.metadata.tooltip) : null,"color":_vm.iconColor},on:{"click":_vm.downloadDocument}},[_vm._v(" "+_vm._s(_vm.metadata.icon || 'mdi-download')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }